const JUMIO = 'jumio';

const hasJumioMethod = (items) =>
  Boolean(items.find((i) => i.verification_methods.includes(JUMIO)));

export default hasJumioMethod;
